import React from 'react';

import { formatAmount } from './AmountHelper';

interface IProps {
    value: number | string;
    round?: boolean;
}

export type IAmountProps = IProps;

export const Amount: React.FC<IAmountProps> = (props) => {
    return <>{formatAmount(props.value, props.round)}</>;
};

Amount.displayName = 'Amount';
